<app-page-body>

  <!-- header -->
  <app-page-header [title]="title" [isForm]="true" [loading]="loading" (onBack)="onClose()"
    (onRefresh)="onReset()" [showRefreshBtn]="false">
  </app-page-header>


  <!-- content -->
  <div class="app-page-content">

    <div class="row">

      <div class="md:tw-w-2/3 offset-md-2">

        <form [formGroup]="form"  autocomplete="off">

          <fieldset>

            <mobile-numbers-widget [title]="'pages.blackList.title'|translate" uniqId="blackList" [correctRows]="10" [wrongRows]="10"
              responsiveClass="md:tw-w-1/2" [form]="form" groupName="blackList" controlName="mobileNumbers"
              (mobileNumbers)="mobileNumbers=$event">
            </mobile-numbers-widget>

          </fieldset>

          <!-- form btns-->
          <app-form-btns [loading]="loading" [form]="form" [isEdit]="false" (onClose)="onClose()" (onSubmit)="onSubmit()">
          </app-form-btns>

        </form>
      </div>

    </div>

  </div>

</app-page-body>
